import {
  MAX_OFFSET,
  MAX_TIMEZONE,
  MIN_TIMEZONE,
  TIMEZONE_OFFSETS,
  TIMEZONES,
} from './constants.js';
import { type Timezone, type TimezoneOffset } from './types.js';

/**
 * Check if a number represents a valid primaryUTC value
 */
const validateTimezoneUtc = (timezone?: number): timezone is number => {
  return (
    timezone !== undefined &&
    Number.isNaN(timezone) === false &&
    timezone >= MIN_TIMEZONE &&
    timezone <= MAX_TIMEZONE
  );
};

/**
 * Get full Timezone from numeric utc value.
 */
export const getTimezoneByUtcOffset = (
  utcOffset: number | undefined,
): null | Timezone => {
  const isValidTimezoneUtcOffset = validateTimezoneUtc(utcOffset);

  if (isValidTimezoneUtcOffset) {
    const utcOffsetNumber = Number(utcOffset);
    return (
      TIMEZONES.find((timezone) => timezone.offset === utcOffsetNumber) ?? null
    );
  }

  return null;
};

/**
 * Check if a number represents a valid offset value
 */
const validateOffset = (offset?: number): offset is number => {
  return (
    offset !== undefined &&
    Number.isNaN(offset) === false &&
    Number.isInteger(Number(offset)) &&
    offset > 0 &&
    offset <= MAX_OFFSET
  );
};

/**
 * Get full TimezoneOffset from numeric offset value. Coerces to number.
 */
export const getOffset = (
  offset: number | undefined,
): null | TimezoneOffset => {
  const isValidOffset = validateOffset(offset);
  if (isValidOffset) {
    return (
      TIMEZONE_OFFSETS.find(
        (offsetItem) => offsetItem.offset === Number(offset),
      ) ?? null
    );
  }

  return null;
};
